import React, { useEffect, useRef, useState } from "react";
import Colors from "../../../../Constants/Colors";
import Icons from "../../../../Constants/Icons";
import Header from "../../../../Components/Header/Header";
import Rejectededlist from "./Customelist/Rejectededlist";
import EmptyData from "../../../../Components/EmptyData/EmptyData";
import {
  getAstrologerApproveOrRejectApi,
  postDeleteAstrologer,
  setAstrologerRegisterStatusApi,
} from "../../../../Core/Apicall";
import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../../../Config/Actions/loadingActions";
import { useDispatch } from "react-redux";
import UseDebounce from "../../../../Components/UseDebounce";

function Rejected() {
  const dispatch = useDispatch();
  const [rejectedListData, setRegectedListData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [totalAstrologer, setTotalAstrologer] = useState(0);
  const [pageComments, setPageComments] = useState(0);
  const commentsContainerRef = useRef(null);


  const debouncedInput = UseDebounce(searchValue, 500);

  useEffect(() => {
    setPageComments(0)
    setRegectedListData([])
    onRejectedListApi(searchValue, 0);
  }, [debouncedInput]);

  const onRejectedListApi = (item, pageComments) => {
    let param = {
      offset: 30 * pageComments,
      limit: 30,
      search: item,
    };
    let data = {
      type: "reject",
    };
    dispatch(setLoadingTrue());
    getAstrologerApproveOrRejectApi(param, data)
      .then((response) => {
        setTotalAstrologer(Math.ceil(response.total / 30));
        setRegectedListData((prevData) => [...prevData, ...response.data]);
        dispatch(setLoadingFalse());
      })
      .catch((err) => {
        dispatch(setLoadingFalse());
      });
  };

  const handleInputChange = (e) => {
    const searchText = e.target.value;
    setSearchValue(searchText);
  };

  const onClickOnMoveApproved = (item) => {
    let param = {
      astrologerId: item.astrologerId,
      processStatus: "approved",
    };
    dispatch(setLoadingTrue());
    setAstrologerRegisterStatusApi(param)
      .then((response) => {
        setRegectedListData((prevData) =>
          prevData.filter((data) => data.astrologerId !== item.astrologerId)
        );
        
        dispatch(setLoadingFalse());
      })
      .catch((err) => {
        dispatch(setLoadingFalse());
      });
  };

  const onDeleteAtrologer = (item) => {
    let param = {
      astrologerId: item.astrologerId,
    };
    dispatch(setLoadingTrue());
    postDeleteAstrologer(param)
      .then(() => {
        setRegectedListData((prevData) =>
          prevData.filter((data) => data.astrologerId !== item.astrologerId)
        );
       
        dispatch(setLoadingFalse());
      })
      .catch((err) => {
        dispatch(setLoadingFalse());
      });
  };

  const handleScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } =
      commentsContainerRef?.current;
    if (scrollTop + clientHeight + 1 > scrollHeight) {
      if (totalAstrologer > pageComments + 1) {
        setPageComments((prevPage) => {
          const nextPage = prevPage + 1;
          onRejectedListApi(searchValue, nextPage);
          return nextPage;
        });
      }
    }
  };

  return (
    <div
      style={{
        padding: 20,
        backgroundColor: Colors.darkBlack,
      }}
    >
      <Header name={"Astrologers / Rejected "} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          gap: "1rem",
        }}
      >
        <div className="astrologers-list-parent">
          <div className="fontSize24">Astrologers list</div>
          <div className="frame-parent2">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                gap: "1rem",
                fontSize: "1rem",
                color: "rgba(255, 255, 255, 0.5)",
              }}
            >
              <div
                style={{
                  borderRadius: "8px",
                  border: "1px solid rgba(255, 255, 255, 0.1)",
                  boxSizing: "border-box",
                  width: "15.75rem",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  padding: "0.5rem 0.5rem",
                  gap: "0.5rem",
                }}
              >
                <img
                  style={{
                    position: "relative",
                    width: "1.5rem",
                    height: "1.5rem",
                    objectFit: "contain",
                  }}
                  alt=""
                  src={Icons.ic_search}
                />
                <input
                  type="text"
                  className="searchTextInput"
                  placeholder="Search"
                  value={searchValue}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            alignSelf: "stretch",
            flex: 1,
            border: Colors.darkBorderColor,
            borderRadius: "8px",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "1rem",
            marginTop: "10px",
          }}
        >
          <div
            style={{
              backgroundColor: Colors.borderColor,
              borderBottom: Colors.darkBorderColor,
              alignSelf: "stretch",
              flex: "1",
              padding: "1rem",
            }}
          >
            <div
              style={{
                alignSelf: "stretch",
                flex: "1",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                // padding: "1rem",
                gap: "0.5rem",
              }}
            >
              <div style={{ width: "20%" }} className="contentName">
                Registration ID
              </div>
              <div style={{ width: "16%" }} className="contentName">
                Name
              </div>
              <div style={{ width: "22%" }} className="contentName">
                Contact
              </div>
              <div style={{ width: "9%" }} className="contentName">
                Experience
              </div>
              <div style={{ width: "24%" }} className="contentName">
                Expertise
              </div>
              <div style={{ width: "7%" }} className="contentName">
                Gender
              </div>
              <div style={{ width: "2%" }}></div>
            </div>
          </div>
          <Rejectededlist
            handleScroll={handleScroll}
            commentsContainerRef={commentsContainerRef}
            onClickDelete={onDeleteAtrologer}
            onClickOnMoveApproved={onClickOnMoveApproved}
            data={rejectedListData}
          />
        </div>
        {rejectedListData.length <= 0 && <EmptyData />}
      </div>
    </div>
  );
}

export default Rejected;
